import { useState } from 'react';
import SafeIcon from '../common/SafeIcon';
import { bookingPlatforms } from '../data/bookingPlatforms';

export default function RoomBookingOptions({ room }) {
  const [open, setOpen] = useState(false);

  return (
    <div className="room-booking-options">
      <button
        className="button button-gold"
        type="button"
        aria-expanded={open}
        aria-controls="room-booking-choices"
        onClick={() => setOpen((current) => !current)}
      >
        Book this room <SafeIcon name="ArrowRight" />
      </button>
      {open && (
        <div className="room-booking-choices" id="room-booking-choices">
          <span className="eyebrow">Choose how to book</span>
          <a className="room-booking-choice" href="#booking-request">
            <span>Book via our Website<small>Ask us about your dates</small></span>
            <SafeIcon name="ArrowRight" />
          </a>
          {bookingPlatforms.map((platform) => (
            <a
              className="room-booking-choice"
              href={platform.url}
              target="_blank"
              rel="noopener noreferrer"
              key={platform.name}
            >
              <span>Book via {platform.name}<small>{room[platform.priceKey]?.trim() || 'See current price on platform'}</small></span>
              <SafeIcon name="ArrowUpRight" />
            </a>
          ))}
          <p>Platform prices may change. Confirm the final price and availability on the booking platform.</p>
        </div>
      )}
    </div>
  );
}